import { API_URL } from "./Config";
import { formatDate } from "./DateUtils";
import {
  GetComplianceInvestigationDetailsAsync,
  IComplianceInvestigationDetails,
} from "./IComplianceInvestigation";
import { IDetailsResponse } from "./IDetailsResponse";
import { GetLicenseDetailsAsync } from "./LicenceDetails";
import { PageResult } from "./Pagination";

/*
 "licenseereturnid": "4e8aadee-e69b-e811-a308-0050568a2d1a",
        "reference": "LR036244",
        "subject": "Site Updates/Notifications Licensee Public Response",
        "datereceived": "2018-08-09T00:00:00",
        "doctype": "Site Updates/Notifications",
        "docsubtype": "Licensee Public Response",
        "decision": "Assessed"
*/
export interface ILicenseeReturn {
  licenseereturnid: string;
  reference: string;
  subject: string;
  datereceived: string;
  doctype: string;
  docsubtype: string;
  decision: string;
}

export interface ILicenseeReturnDetails extends IDetailsResponse {
  licenseereturnid: string;
  type: string;
  reference: string;
  subject: string;
  status: string;
  licenceid: string;
  licence_regno: string;
  licenceprofileid: string;
  datereceived: string;
  closeddate: string;
  title: string;
  doctype: string;
  docsubtype: string;
  decision: string;
  description: string;
  documentcategory: string;
  complianceinvestigationid: string;
  complianceInvestigationDetails?: IComplianceInvestigationDetails;
}

export interface ILicenseeReturnList extends PageResult {
  list: ILicenseeReturn[];
}

export const GetLicenseeReturnFromSiteVisitFetchUrl = (
  siteVisitId: string,
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any
) => {
  var params = `&page=${pageNo}&per_page=${recordsPerPage}`;

  let url = `${API_URL}/LicenseeReturns/listbysvid?sv_id=${siteVisitId}${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/licenseereturns-sitevisit`;
  }

  return url;
};

export const GetLicenseeReturnFromComplianceInvestigationFetchUrl = (
  complianceInvestigationId: string,
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any
) => {
  var params = `&page=${pageNo}&per_page=${recordsPerPage}`;

  let url = `${API_URL}/LicenseeReturns/listbyciid?ci_id=${complianceInvestigationId}${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/licenseereturns-ci`;
  }

  return url;
};

export async function GetLicenseeReturnDetailsAsync(
  siteVisitId: string
): Promise<ILicenseeReturnDetails> {
  var url = `${API_URL}/LicenseeReturns/byid?lr_id=${siteVisitId}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/licenseereturn-details-notfound`;
  }

  var response = await fetch(url);
  var body = <ILicenseeReturnDetails>await response.json();

  const licenceDetails = await GetLicenseDetailsAsync(body.licenceid);

  if (body.complianceinvestigationid) {
    body.complianceInvestigationDetails =
      await GetComplianceInvestigationDetailsAsync(
        body.complianceinvestigationid
      );
  }

  return <ILicenseeReturnDetails>{
    response: response,
    licenseereturnid: body.licenseereturnid,
    type: body.type,
    reference: body.reference,
    subject: body.subject,
    status: body.status,
    licenceid: body.licenceid,
    licence_regno: licenceDetails.reg_no,
    licenceprofileid: body.licenceprofileid,
    datereceived: formatDate(body.datereceived),
    closeddate: formatDate(body.closeddate),
    title: body.title,
    doctype: body.doctype,
    docsubtype: body.docsubtype,
    decision: body.decision,
    description: body.description,
    documentcategory: body.documentcategory,
    complianceinvestigationid: body.complianceinvestigationid,
    complianceInvestigationDetails: body.complianceInvestigationDetails,
  };
}
